import React, { useState } from 'react'
import PropTypes from 'prop-types'

const StarRating = ({ totalStars = 5 }) => {
  const [rating, setRating] = useState(0)
  const [hoverRating, setHoverRating] = useState(0)

  const handleClick = (value) => {
    setRating(value)
  }

  const handleMouseOver = (e, value) => {
    setHoverRating(value)
  }

  const handleMouseLeave = () => {
    setHoverRating(0)
  }
  const renderStars = () => {
    const stars = []
    for (let i = 1; i <= totalStars; i++) {
      const starValue = i
      stars.push(
        <span
          key={i}
          className={`star ${starValue <= (hoverRating || rating) ? 'filled' : ''} `}
          onClick={() => handleClick(starValue)}
          onMouseEnter={(e) => {
            handleMouseOver(e, starValue)
          }}
          onMouseLeave={handleMouseLeave}>
          ★
        </span>
      )
    }
    return stars
  }

  return <div className="star-rating">{renderStars()}</div>
}

StarRating.propTypes = {
  totalStars: PropTypes.number,
}
export default StarRating
